// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3nmEf","approved":"Status_approved__3G2eP","rejected":"Status_rejected__2PqPD","expired":"Status_expired__2tCnn","label":"Status_label__3c3lx"};